var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignGiftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 67,
    viewBox: "0 0 335 67",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H201.023C210.904 0 220.35 4.06108 227.148 11.2314L238.285 22.9786C245.084 30.1489 254.53 34.21 264.411 34.21H302.21C320.319 34.21 335 48.8906 335 67H0V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignGiftBg);
export default __webpack_public_path__ + "static/media/sign-gift-bg.ca20ad83af1ba3bc87268359f560ecd2.svg";
export { ForwardRef as ReactComponent };